import { Component, Input } from '@angular/core';
import { LoadingIconButtonComponent } from '@app-components/common/loading-icon-button/loading-icon-button.component';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'app-reply-button',
  templateUrl: './reply-button.component.html',
  styleUrls: ['./reply-button.component.scss'],
  imports: [LoadingIconButtonComponent, MatIcon, TranslateModule, MatMenuItem],
})
export class ReplyButtonComponent {
  @Input() isMenu = false;
  @Input() disabled: boolean;
  @Input() showButton: boolean;
  @Input() showLoading: boolean;

  constructor() {}
}
